var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideography(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_80_233)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3625 2.18125L10.1812 0H8.3625L10.5437 2.18125H12.3625ZM0.728125 0H0V2.18125H2.90937L0.728125 0ZM7.6375 2.18125L5.45312 0H3.63438L5.81563 2.18125H7.6375ZM13.0906 5.09062H10.1812L12.3625 2.90937H10.5437L8.3625 5.09062H5.45312L7.63438 2.90937H5.81563L3.63438 5.09062H0.728125L2.90937 2.90937H0V14.5469C0 15.3469 0.653125 16 1.45312 16H14.5437C15.3469 16 15.9969 15.3469 15.9969 14.5469V2.90937H15.2688L13.0906 5.09062ZM5.81875 13.8188V7.27187L11.6375 10.5437L5.81875 13.8188ZM13.0906 0L15.2719 2.18125H16V0H13.0906Z",
    fill: "#016E82"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_80_233"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideography);
export default __webpack_public_path__ + "static/media/Videography.62a4bba9b56d017ca01628b064d0a364.svg";
export { ForwardRef as ReactComponent };